/**
 * THE LEVEL BOUNDARY IN A `/users/mission-context` PAYLOAD, SPELLED ONCE.
 *
 * `PersonalMissionService::read` moves the position to the next capsule once a
 * level's lessons, quests and progress report are done, and then omits the
 * finished level's `lesson`; no `module` is sent because a lesson row exists.
 * The new position is stated as `context.capsule_id`, with `nextLesson` rooted
 * at the same capsule. The user slice's advance reducers and the experience
 * selectors both read these two facts, so they live here and nowhere else.
 */

/**
 * Is this mission at a level boundary? It names neither a lesson nor a module.
 *
 * @param {object|null|undefined} mission `state.user.mission`
 * @returns {boolean}
 */
export const isBoundaryMission = (mission) =>
  !!mission && !mission.lesson && !mission.module;

/**
 * The capsule a boundary payload states as the position: `context.capsule_id`,
 * then `nextLesson.capsule_id` where the context carries none. Raw, in the
 * server's own type.
 *
 * @param {object} mission
 * @returns {number|string|null|undefined}
 */
export const statedBoundaryCapsuleIdOf = (mission) =>
  mission?.context?.capsule_id ?? mission?.nextLesson?.capsule_id;
